import {handleFileSelected} from "../UploadUtils.ts";
import React from "react";

export const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
};

export const handleDrop = async (
    e: React.DragEvent,
    userObjRef: any,
    settingsObjRef: any,
    updateSelectedMedia: (element: any, operation: string) => void,
    websocketRef: any,
    setupWebsocketHelper: any,
    setDynamicStateObj?: any
) => {
    e.preventDefault();
    e.stopPropagation();

    const files: File[] = Array.from(e.dataTransfer.files);
    files.map(async (file: any) => {
        await handleFileSelected(file, userObjRef, settingsObjRef, updateSelectedMedia, websocketRef, setupWebsocketHelper, setDynamicStateObj);
    });
};